import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import styles from "../../styles/pages/mymessagePurchasedRequest.module.scss";
import React, { useEffect } from "react";

const PurchaseRequestDecision = ({ initialValue, onUpdate }) => {
  const [selectedValue, setSelectedValue] = React.useState(initialValue);

  useEffect(() => {
    setSelectedValue(initialValue);
  }, [initialValue]);

  console.warn("selectedValue", selectedValue);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    onUpdate(newValue);
  };

  return (
    <Box className={styles.decisionBox}>
      <h4>Decision:</h4>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={selectedValue}
          onChange={handleChange}
        >
          <FormControlLabel value="1" control={<Radio />} label="Approve" />
          <FormControlLabel value="2" control={<Radio />} label="Reject" />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default PurchaseRequestDecision;
